export default __webpack_public_path__ + "static/media/bb20.ba802979.webp";